document.addEventListener('DOMContentLoaded', () => {
  /* Mega-menu thumbnails are emitted with data-src instead of src so they
     are not fetched on page load — the menu ships ~45 product images that
     most visitors never open. Swap them in the first time the menu is
     revealed, then stop watching. */
  (function deferMegaMenuImages() {
    const swap = (root) => {
      root.querySelectorAll('img[data-src]').forEach((img) => {
        img.src = img.getAttribute('data-src');
        img.removeAttribute('data-src');
      });
    };
    const menu = document.getElementById('megaMenu');
    const trigger = document.getElementById('categoriesToggle');
    if (!menu) return;
    let done = false;
    const load = () => {
      if (done) return;
      done = true;
      swap(menu);
    };
    // Any intent to open the menu is enough to start fetching.
    ['mouseenter', 'focusin', 'touchstart'].forEach((evt) => {
      menu.addEventListener(evt, load, { once: true, passive: true });
      if (trigger) trigger.addEventListener(evt, load, { once: true, passive: true });
    });
    if (trigger) trigger.addEventListener('click', load, { once: true });
    // On the homepage the rail is permanently visible, so load when it scrolls in.
    if (document.body.classList.contains('template-index') && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { load(); io.disconnect(); }
      }, { threshold: 0.01 });
      io.observe(menu);
    }
  })();

  // Mega Menu Tab Logic
  const megaSidebarItems = document.querySelectorAll('.mega-sidebar-item');
  megaSidebarItems.forEach(item => {
    item.addEventListener('mouseenter', function() {
      // Find the parent mega menu wrapper to scope our changes
      const wrapper = this.closest('.nav-mega-content');
      if (!wrapper) return;

      // Remove active class from all items in this sidebar
      wrapper.querySelectorAll('.mega-sidebar-item').forEach(el => el.classList.remove('active'));
      // Remove active class from all panes in this middle section
      wrapper.querySelectorAll('.mega-pane').forEach(el => el.classList.remove('active'));

      // Add active to current hovered
      this.classList.add('active');
      
      // Add active to target pane
      const targetId = this.getAttribute('data-target');
      const targetPane = wrapper.querySelector('#' + targetId);
      if (targetPane) {
        targetPane.classList.add('active');
      }
    });
  });

  // Category Mega Menu Hover Logic
  const catHoverItems = document.querySelectorAll('.cat-hover-item');

  /* In the mobile drawer the sub-categories expand inline underneath their
     parent rather than flying out to a side panel — a 320px drawer has no
     room to the right. Tapping a category toggles its list; the link itself
     is suppressed on the first tap so the sub-list is reachable. */
  /* Must match the CSS breakpoint that styles the drawer (max-width: 767px).
     Using 1024 here moved the panes out of .mega-category-panes and disabled
     hover between 768-1024px, where the CSS still expects the desktop
     fly-out — which broke the slide-out panel on small desktops/tablets. */
  const MOBILE_DRAWER = () => window.innerWidth <= 767;

  /* Relocate each category pane to sit immediately after its own link in the
     nav list. In the markup all panes live in .mega-category-panes AFTER
     </nav>, which is right for the desktop fly-out but would stack every
     sub-list below the last category in the drawer. Done once, and only for
     the drawer width; desktop keeps the original structure. */
  (function inlineDrawerPanes() {
    const home = document.querySelector('.mega-category-panes');
    if (!home) return;
    let moved = false;

    const toDrawer = () => {
      if (moved) return;
      moved = true;
      document.querySelectorAll('.cat-hover-item[data-target]').forEach(item => {
        const pane = document.getElementById(item.getAttribute('data-target'));
        if (pane && item.parentNode) item.insertAdjacentElement('afterend', pane);
      });
    };

    // Put the panes back in their container, or the desktop fly-out has
    // nothing to show — a visitor who resizes down and back up would
    // otherwise be left with the panes stranded inside the category list.
    const toDesktop = () => {
      if (!moved) return;
      moved = false;
      document.querySelectorAll('.cat-pane').forEach(pane => {
        pane.classList.remove('is-open');
        home.appendChild(pane);
      });
      document.querySelectorAll('.cat-hover-item.is-open')
        .forEach(el => el.classList.remove('is-open'));
    };

    const sync = () => (MOBILE_DRAWER() ? toDrawer() : toDesktop());

    sync();
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(sync, 150);
    });
    const burger = document.getElementById('mobileMenuToggle');
    if (burger) burger.addEventListener('click', sync);
  })();

  catHoverItems.forEach(item => {
    item.addEventListener('click', function (e) {
      if (!MOBILE_DRAWER()) return;
      const targetId = this.getAttribute('data-target');
      if (!targetId) return;                       // leaf link — let it navigate
      const pane = document.getElementById(targetId);
      if (!pane) return;

      const isOpen = pane.classList.contains('is-open');
      if (!isOpen) {
        e.preventDefault();                        // first tap opens the list
        // Accordion: only one category open at a time.
        document.querySelectorAll('.cat-pane.is-open').forEach(p => p.classList.remove('is-open'));
        document.querySelectorAll('.cat-hover-item.is-open').forEach(el => el.classList.remove('is-open'));
        pane.classList.add('is-open');
        this.classList.add('is-open');
      } else {
        e.preventDefault();                        // second tap closes it
        pane.classList.remove('is-open');
        this.classList.remove('is-open');
      }
    });

    item.addEventListener('mouseenter', function() {
      if (MOBILE_DRAWER()) return;                 // hover panes are desktop-only
      const container = this.closest('.mega-menu-container');
      if (!container) return;
      
      container.querySelectorAll('.cat-hover-item').forEach(el => el.classList.remove('active'));
      container.querySelectorAll('.cat-pane').forEach(el => el.classList.remove('active'));
      
      this.classList.add('active');
      const targetId = this.getAttribute('data-target');
      const targetPane = container.querySelector('#' + targetId);
      const megaPanesContainer = container.querySelector('.mega-category-panes');
      
      if (targetPane) {
         targetPane.classList.add('active');
         if (megaPanesContainer) {
           megaPanesContainer.classList.add('active-pane-visible');
         }
      } else {
         if (megaPanesContainer) {
           megaPanesContainer.classList.remove('active-pane-visible');
         }
      }
    });
  });

  const allCategoriesBtn = document.querySelector('.all-categories-btn');
  if (allCategoriesBtn) {
    allCategoriesBtn.addEventListener('mouseleave', () => {
      document.querySelectorAll('.cat-hover-item').forEach(el => el.classList.remove('active'));
      document.querySelectorAll('.cat-pane').forEach(el => el.classList.remove('active'));
      const megaPanesContainer = document.querySelector('.mega-category-panes');
      if (megaPanesContainer) {
        megaPanesContainer.classList.remove('active-pane-visible');
      }
    });
  }

  const categoriesToggle = document.getElementById('categoriesToggle');
  const megaMenu = document.getElementById('megaMenu');
  
  if (categoriesToggle && megaMenu) {
    categoriesToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      categoriesToggle.classList.toggle('active');
    });

    // Close on click outside
    document.addEventListener('click', (e) => {
      if (!megaMenu.contains(e.target) && !categoriesToggle.contains(e.target)) {
        categoriesToggle.classList.remove('active');
      }
    });

    // Close on Escape so keyboard users can dismiss the menu.
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') categoriesToggle.classList.remove('active');
    });
  }

  // Predictive Search Logic
  // Runs once per search form on the page: the header carries one, and the
  // search page carries another (which is also what mobile users get, since
  // the header form collapses to an icon below 940px). Each instance scopes
  // its lookups to its own form so the two never drive each other's dropdown.
  document.querySelectorAll('.ballistol-search-input').forEach(function (inputEl) {
  (function () {
    const searchInput = inputEl;
    const scope = inputEl.closest('.header-search-section, .search-header') || document;
    const searchWrapper = scope.querySelector('.predictive-search-wrapper');
    const searchLoading = scope.querySelector('.predictive-search-loading');
    const searchResults = scope.querySelector('.predictive-search-results');
    const viewAllBtn = scope.querySelector('.predictive-search-view-all');
    if (!searchInput || !searchWrapper) return;

    const escapeHtml = (s) => {
      const d = document.createElement('div');
      d.textContent = s == null ? '' : String(s);
      return d.innerHTML;
    };
    const show = (el) => { if (el) el.hidden = false; };
    const hide = (el) => { if (el) el.hidden = true; };
    const setExpanded = (v) => searchInput.setAttribute('aria-expanded', v ? 'true' : 'false');

    let searchTimeout;
    let currentAbort;
    let activeIndex = -1;

    const getItems = () => Array.from(searchResults.querySelectorAll('.search-result-item'));

    const highlight = (idx) => {
      const items = getItems();
      items.forEach((el, i) => {
        const on = i === idx;
        el.classList.toggle('is-active', on);
        if (on) {
          el.setAttribute('aria-selected', 'true');
          searchInput.setAttribute('aria-activedescendant', el.id || '');
          el.scrollIntoView({ block: 'nearest' });
        } else {
          el.removeAttribute('aria-selected');
        }
      });
      activeIndex = idx;
      if (idx === -1) searchInput.removeAttribute('aria-activedescendant');
    };

    const closeDropdown = () => {
      hide(searchWrapper);
      setExpanded(false);
      activeIndex = -1;
    };

    document.addEventListener('click', (e) => {
      if (!searchInput.contains(e.target) && !searchWrapper.contains(e.target)) closeDropdown();
    });

    searchInput.addEventListener('focus', (e) => {
      if (e.target.value.trim().length > 2 && searchResults.children.length > 0) {
        show(searchWrapper);
        setExpanded(true);
      }
    });

    searchInput.addEventListener('keydown', (e) => {
      if (searchWrapper.hidden) return;
      const items = getItems();
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        highlight(Math.min(items.length - 1, activeIndex + 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        highlight(Math.max(-1, activeIndex - 1));
      } else if (e.key === 'Enter') {
        if (activeIndex >= 0 && items[activeIndex]) {
          e.preventDefault();
          window.location.href = items[activeIndex].href;
        }
      } else if (e.key === 'Escape') {
        closeDropdown();
      }
    });

    searchInput.addEventListener('input', (e) => {
      clearTimeout(searchTimeout);
      const query = e.target.value.trim();

      // Suggest from the second character: short product names like "oil"
      // and typo-prone queries were previously invisible until 3+ chars.
      if (query.length < 2) {
        closeDropdown();
        return;
      }

      show(searchWrapper);
      setExpanded(true);
      show(searchLoading);
      searchResults.innerHTML = '';
      hide(viewAllBtn);
      activeIndex = -1;

      searchTimeout = setTimeout(() => {
        if (currentAbort) currentAbort.abort();
        currentAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;
        const url = '/search/suggest.json?q=' + encodeURIComponent(query) +
                    '&resources[type]=product&resources[limit]=10';

        fetch(url, currentAbort ? { signal: currentAbort.signal } : undefined)
          .then(res => res.json())
          .then(data => {
            hide(searchLoading);
            let products = (data && data.resources && data.resources.results && data.resources.results.products) || [];

            if (products.length > 0) {
              // Relevance nudge: exact > starts-with > includes > default
              const q = query.toLowerCase();
              products.sort((a, b) => {
                const aT = a.title.toLowerCase();
                const bT = b.title.toLowerCase();
                if (aT === q && bT !== q) return -1;
                if (bT === q && aT !== q) return 1;
                const aS = aT.startsWith(q), bS = bT.startsWith(q);
                if (aS && !bS) return -1;
                if (!aS && bS) return 1;
                const aH = aT.includes(q), bH = bT.includes(q);
                if (aH && !bH) return -1;
                if (!aH && bH) return 1;
                return 0;
              });
              products = products.slice(0, 5);

              searchResults.innerHTML = products.map((p, i) => {
                const title = escapeHtml(p.title);
                const price = escapeHtml(p.price);
                const imgTag = p.image
                  ? '<img src="' + escapeHtml(p.image) + '" alt="' + title + '" class="search-result-image" loading="lazy" decoding="async">'
                  : '';
                return (
                  '<a href="' + escapeHtml(p.url) + '"' +
                  ' id="ps-result-' + i + '"' +
                  ' class="search-result-item"' +
                  ' role="option"' +
                  ' tabindex="-1">' +
                    imgTag +
                    '<div class="search-result-info">' +
                      '<span class="search-result-title">' + title + '</span>' +
                      '<span class="search-result-price">' + price + '</span>' +
                    '</div>' +
                  '</a>'
                );
              }).join('');
              show(viewAllBtn);
              viewAllBtn.href = '/search?type=product&q=' + encodeURIComponent(query);
            } else {
              searchResults.innerHTML = '<div style="padding:15px;text-align:center;color:#888;">No products found for "' + escapeHtml(query) + '"</div>';
            }
          })
          .catch(err => {
            if (err && err.name === 'AbortError') return;
            console.error('Predictive search error:', err);
            hide(searchLoading);
          });
      }, 180);
    });
  })();
  });

  // Mobile Menu Drawer Logic
  const mobileMenuToggle = document.getElementById('mobileMenuToggle');
  const mobileCloseBtn = document.getElementById('mobileCloseBtn');
  const headerNavigationBar = document.getElementById('headerNavigationBar');
  const mobileNavOverlay = document.getElementById('mobileNavOverlay');

  if (mobileMenuToggle && headerNavigationBar) {
    mobileMenuToggle.addEventListener('click', () => {
      headerNavigationBar.classList.add('open');
      if(mobileNavOverlay) mobileNavOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      // Auto-open All Categories on mobile
      const catToggle = document.getElementById('categoriesToggle');
      if (catToggle && window.innerWidth <= 767) {
        catToggle.classList.add('active');
      }
    });
  }

  /* COMPANY / USES collapse in the mobile drawer. Their parent is a real
     link, so the first tap opens the sub-list instead of navigating; a
     second tap on the same parent follows the link. Desktop keeps hover. */
  (function drawerNavAccordion() {
    const wrappers = document.querySelectorAll('.nav-dropdown-wrapper, .nav-mega-wrapper');
    wrappers.forEach(wrapper => {
      const parentLink = wrapper.querySelector(':scope > .nav-item');
      const panel = wrapper.querySelector(':scope > .nav-dropdown-content, :scope > .nav-mega-content');
      if (!parentLink || !panel) return;

      parentLink.addEventListener('click', function (e) {
        if (window.innerWidth > 767) return;          // desktop: hover handles it
        if (wrapper.classList.contains('is-open')) return;  // second tap navigates
        e.preventDefault();
        // One section open at a time, and never collapse All Categories.
        wrappers.forEach(w => { if (w !== wrapper) w.classList.remove('is-open'); });
        wrapper.classList.add('is-open');
      });
    });
  })();

  // Categories start expanded in the mobile drawer so the list is visible
  // the moment it opens, rather than needing a second tap.
  (function defaultCategoriesOpen() {
    const catToggle = document.getElementById('categoriesToggle');
    if (catToggle && window.innerWidth <= 767) catToggle.classList.add('active');
  })();

  // The mobile auto-open state must not survive into the desktop layout,
  // where .active would hold the dropdown open over the hero.
  window.addEventListener('resize', () => {
    if (window.innerWidth > 767) {
      const catToggle = document.getElementById('categoriesToggle');
      if (catToggle) catToggle.classList.remove('active');
    }
  });

  function closeMobileNav() {
    if(headerNavigationBar) headerNavigationBar.classList.remove('open');
    if(mobileNavOverlay) mobileNavOverlay.classList.remove('active');
    document.body.style.overflow = '';
    // The categories list stays expanded: it is the drawer's default state,
    // and clearing it here meant the next open started collapsed. Any
    // inline sub-lists are reset so the drawer reopens at the top level.
    document.querySelectorAll('.cat-pane.is-open').forEach(p => p.classList.remove('is-open'));
    document.querySelectorAll('.cat-hover-item.is-open').forEach(el => el.classList.remove('is-open'));
    document.querySelectorAll('.nav-dropdown-wrapper.is-open, .nav-mega-wrapper.is-open')
      .forEach(w => w.classList.remove('is-open'));
  }

  if (mobileCloseBtn) {
    mobileCloseBtn.addEventListener('click', closeMobileNav);
  }
  if (mobileNavOverlay) {
    mobileNavOverlay.addEventListener('click', closeMobileNav);
  }

  // Header Cart Toggle
  const headerCartLink = document.getElementById('headerCartLink');
  if(headerCartLink) {
    headerCartLink.addEventListener('click', (e) => {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('cart:open'));
    });
  }
});
